// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"188":"927563e2","520":"8064eba0","803":"a3a09cc7","939":"075bd110"}[chunkId] + ".chunk.css";
};